export enum HourGridDensity {
  COMPACT = "compact",
  COMFORTABLE = "comfortable",
  EXPANDED = "expanded",
}
